import React from "react";
import {useSelector} from "react-redux";
import {Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

import theme from "../../../components/styles/theme/theme";
import {RootState} from "../../../store/store";
import {regionEnv, REGIONS_NAME} from "../../../config";

const Header: React.FC = () => {
    const {
        map: {year, selectedCountry},
    } = useSelector((state: RootState) => state);
    const {t} = useTranslation();

    const formattedYear = `<span style="color: red;">${year}</span>`;
    const joinTranslation = t("common.in");

    const regionName =
        regionEnv === REGIONS_NAME.ROMANIA ? t("common.romania") : regionEnv;

    const formattedSelectedCountry = `<span style="color: red;">${
        selectedCountry ? selectedCountry.country_name : regionName
    }</span>`;

    const interpolatedTitle = t("common.coca_cola_impact_title", {
        year: formattedYear,
        joinTranslation: joinTranslation,
        selectedCountry: formattedSelectedCountry,
    });

    return (
        <Grid
            container
            spacing={2}
            columns={1}
            sx={{textAlign: "left"}}
            padding="0 40px 25px 40px"
        >
            <Grid item xs={1}>
                <Typography
                    variant="h4"
                    component="h4"
                    lineHeight="37px"
                    fontWeight="600"
                    fontSize="31px"
                    color={theme.palette.component["900"]}
                    dangerouslySetInnerHTML={{__html: interpolatedTitle}}
                />
            </Grid>
            <Grid item xs={1} className="hidden-print">
                <Typography
                    variant="body1"
                    component="p"
                    color={theme.palette.component["900"]}
                    lineHeight="19px"
                    padding="8px 0"
                >
                    {t(`common.coca_cola_impact_description_${regionEnv}`)}
                </Typography>
            </Grid>
        </Grid>
    );
};

export default Header;
